'use strict';

window.app = {
    device: {
        mobile: Number('0'.replace(/\D/g, '')),
        tablet: Number('768'.replace(/\D/g, '')),
        desktop: Number('1024'.replace(/\D/g, '')),
    },
    window: {
        height: () => $(window).height(),
        width: () => $(window).width(),
    },
    grid: {
        xs: 0,
        sm: '374',
        md: '767',
        lg: '1025',
        xl: '1278',
    },
    /**
     * Is Tablet
     * @return {boolean} - Whether is tablet
     */
    isTablet: function () {
        return window.matchMedia('(min-width:' + this.device.tablet + 'px)').matches;
    },
    /**
     * Is Desktop
     * @return {boolean} - Whether is desktop
     */
    isDesktop: function () {
        return window.matchMedia('(min-width:' + this.device.desktop + 'px)').matches;
    },
    /**
     * Is Mobile
     * @return {boolean} - Whether is mobile
     */
    isMobile: function () {
        return !this.isDesktop();
    },
    /**
     * Check if the current view is matching a grid breakpoint
     * @param {string} breakPoint Breakpoint name (xs, sm, md, lg, xl, xxl, xxxl, xxxxl)
     * @returns {boolean} True if the breakpoint matches the current viewport
     */
    checkBreakPoint: function (breakPoint) {
        if (Object.keys(this.grid).indexOf(breakPoint) < 0) {
            // Breakpoint not supported
            return false;
        }
        return window.matchMedia('(min-width:' + this.grid[breakPoint] + 'px)').matches;
    },
    /**
     * Returns the current device as a string
     * @returns {string} The current device as string
     */
    getCurrentDevice: function () {
        if (this.isDesktop()) {
            return 'desktop';
        }
        if (this.isTablet()) {
            return 'tablet';
        }
        return 'mobile';
    },
    /**
     * Check if current page is a PDP
     * @returns {boolean} true if current page is a PDP
     */
    isPDP: function () {
        return $('.page-pdp').length > 0;
    },
};
